import React from "react";
import styles from "./NextVisit.module.scss";
import { getCountryFromUrl, trackEvent } from "../utils/helpers";

const AnimText = ({ text }) => (
  <span className={styles.btnText}>
    <span>{text}</span>
  </span>
);

const NextVisit = () => {
  const country = getCountryFromUrl();

  const countryLinks = {
    us: "https://www.flightclubdartsusa.com?utm_source=Stories&utm_medium=cta&utm_campaign=plan_next_visit",
    ie: "https://flightclubdarts.com/ie/book?utm_source=Stories&utm_medium=cta&utm_campaign=plan_next_visit",
    aus: "https://flightclubdarts.com.au/book?utm_source=Stories&utm_medium=cta&utm_campaign=plan_next_visit",
  };

  const ukLink =
    "https://flightclubdarts.com/book?utm_source=Stories&utm_medium=cta&utm_campaign=plan_next_visit";

  const countryLink = countryLinks[country] || ukLink;

  return (
    <div className={styles.nextVisit}>
      <h3>Ready for another round?</h3>
      <h2>
        Lock in your
        <br className={styles.mobileBreak} /> next visit
      </h2>
      <div className={styles.linkWrapper}>
        <a
          href={countryLink}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent("Plan a Visit", "plan_a_visit")}
        >
          <AnimText text="Plan your next visit" />
        </a>
      </div>
    </div>
  );
};

export default NextVisit;
